import { useApp } from '@/App';
import FleetTitle from '@/libs/antd/components/Title';
import { useGetPurchaseOrderDetail } from '@/libs/fleet-api/hooks/purchase-order';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Space, Table } from 'antd';
import dayjs from 'dayjs';
import { FC, useState } from 'react';

const pageSize = 10;

const FBDHPODetailListPage: FC<{
	mppId: number;
	mklNo: string;
	spfNo: string;
	onBack?: () => void;
}> = ({ mppId, mklNo, spfNo, onBack }) => {
	const { navigate } = useApp();
	const [page, setPage] = useState(1);

	// Prepare params for API call
	const params: {
		pagination: { pageSize: number; pageNumber: number };
		mppId: number;
	} = {
		pagination: { pageSize, pageNumber: page },
		mppId,
	};

	const { data, isLoading, error } = useGetPurchaseOrderDetail(params);

	// Table data
	const tableData = (data?.details || []).map((item, idx) => ({
		key: idx + 1 + (page - 1) * pageSize,
		no: idx + 1 + (page - 1) * pageSize,
		noMkl: mklNo,
		noSpf: spfNo,
		noMpp: data?.mppNo,
		noPo: item.purchaseOrderNo,
		applicationId: item.applicationId, // TODO: Recheck data
		noAgreement: '-', // TODO: Use from API
		supplier: item.supplierName,
		merkAsset: item.brand,
		ntf: item.ntfAmount,
		tglTerbitPo: item.purchaseOrderReleaseDate,
		tglPoExpired: item.purchaseOrderExpiredDate,
		tglPerpanjanganPo: item.purchaseOrderExtendDate || '-', // TODO: Verify key
		status: item.status,
		totalUnit: item.totalUnit,
		spfId: item.spfId,
		napResolutionId: item.napResolutionId,
	}));

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<div
				style={{
					display: 'flex',
					gap: 10,
					marginBottom: 30,
				}}
			>
				<div>
					<button
						style={{
							display: 'flex',
							height: 44,
							width: 44,
							fontSize: 24,
							border: 'none',
							alignItems: 'center',
							justifyContent: 'center',
							background: '#1557BC',
							color: 'white',
							cursor: 'pointer',
						}}
						onClick={() => {
							if (onBack) {
								onBack();
							} else {
								navigate('FBDHPOListPage');
							}
						}}
					>
						<ArrowLeftOutlined />
					</button>
				</div>
				<div style={{ flex: 1 }}>
					<FleetTitle>Detail Purchase Order</FleetTitle>
				</div>
			</div>

			<Table
				scroll={{ x: 'max-content' }}
				bordered
				loading={isLoading}
				dataSource={tableData}
				columns={[
					{ title: 'No', dataIndex: 'no', align: 'center', width: 1 },
					{ title: 'No. MKL', dataIndex: 'noMkl' },
					{
						title: 'No. SPF',
						dataIndex: 'noSpf',
						render: (v, record) => (
							<a
								onClick={(e) => {
									e.preventDefault();
									navigate('SPFPage', {
										spfId: record.spfId,
										napResolutionId: record.napResolutionId,
										viewOnly: true,
										onBack: () =>
											navigate('FBDHPODetailListPage', {
												mppId: mppId,
												mklNo: mklNo,
												spfNo: spfNo,
											}),
									});
								}}
							>
								{v}
							</a>
						),
					},
					{ title: 'No. MPP', dataIndex: 'noMpp' },
					{
						title: 'No. PO',
						dataIndex: 'noPo',
						render: (v, record) => (
							<a
								onClick={(e) => {
									e.preventDefault();
									navigate('FBDHPOApprovalListPage', {
										mklNo: mklNo,
										spfNo: spfNo,
										mppId: mppId,
										mppNo: record.noPo,
									});
								}}
							>
								{v}
							</a>
						),
					},
					{ title: 'Application ID', dataIndex: 'applicationId' },
					{ title: 'No Agreement', dataIndex: 'noAgreement' },
					{ title: 'Supplier', dataIndex: 'supplier' },
					{ title: 'Merk Asset', dataIndex: 'merkAsset' },
					{ title: 'Jumlah Unit', dataIndex: 'totalUnit' },
					{ title: 'NTF', dataIndex: 'ntf' },
					{
						title: 'Tanggal Terbit PO',
						dataIndex: 'tglTerbitPo',
						render: (v) => (v ? dayjs(v).format('DD-MM-YYYY') : '-'),
					},
					{
						title: 'Tanggal PO Expired',
						dataIndex: 'tglPoExpired',
						render: (v) => (v ? dayjs(v).format('DD-MM-YYYY') : '-'),
					},
					{ title: 'Tanggal Perpanjangan PO', dataIndex: 'tglPerpanjanganPo' },
					{ title: 'Status', dataIndex: 'status' },
				]}
				pagination={{
					current: page,
					total: data?.details?.length || 0,
					pageSize,
					onChange: setPage,
				}}
				rowKey="key"
			/>
			{error && (
				<div style={{ color: 'red' }}>Gagal memuat detail purchase order.</div>
			)}
		</Space>
	);
};

export default FBDHPODetailListPage;
